/**
 * Meta Pixel helpers. Base pixel (fbq init + PageView) is injected into
 * index.html at build/dev time when VITE_META_PIXEL_ID is set.
 */

type Fbq = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

function getFbq(): Fbq | null {
  if (typeof window === 'undefined') return null;
  return typeof window.fbq === 'function' ? window.fbq : null;
}

/** Fire Meta's standard StartTrial conversion (subscription selection page). */
export function trackMetaStartTrial(params?: { planId?: string }): void {
  try {
    const fbq = getFbq();
    if (!fbq) return;
    if (params?.planId) {
      fbq('track', 'StartTrial', { subscription_id: params.planId });
    } else {
      fbq('track', 'StartTrial');
    }
  } catch {
    /* analytics must never break trial activation */
  }
}
